import { Reveal } from "../components/Reveal";
import { BeforeAfter } from "../components/BeforeAfter";

// Before/after evidence tabs — Air Duct / HVAC active by default; user-driven only.
export function EvidenceExample() {
  return (
    <section className="noise-dark relative overflow-hidden py-12 text-zinc-100 md:py-16" aria-label="Before and after evidence for all five services">
      <div className="absolute inset-0 grid-lines-dark" aria-hidden="true" />
      <div className="container-x relative">
        <Reveal>
          <p className="eyebrow-dark">All five services — photographed both ways</p>
        </Reveal>
        <Reveal delay={0.1} className="mt-8">
          <BeforeAfter dark />
        </Reveal>
      </div>
    </section>
  );
}
